import { useTranslation } from "react-i18next";
import { Card } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";

import GlobeIcon from "@/assets/icons/globe.svg?react";
import CommunityIcon from "@/assets/icons/community.svg?react";
import BaseButton from "@/components_v2/Button/BaseButton.js";
import BaseSvgRenderer from "@/components_v2/Svg/BaseSvgRenderer.js";
import {
  BUTTON_TYPES,
  BUTTON_VARIANTS,
} from "@/components_v2/Button/constants";

import "./styles.css";

const SubmissionSuccess = () => {
  const { t } = useTranslation();

  return (
    <div className="submission-success-container flex justify-center items-center full-width">
      <Card className="submission-success-card full-width">
        <div className="flex flex-col gap-300 items-center">
          <CheckCircleOutlined className="success-icon" />
          <h1 className="header-l-medium">
            {t("survey.labels.reportSubmittedSuccessfully")}
          </h1>
          <p className="body-m-regular">
            {t("survey.labels.reportSubmittedDescription")}
          </p>

          <div className="flex justify-center gap-300 full-width">
            <Card className="report-version-card-public full-width">
              <div className="flex flex-col gap-100 items-center">
                <BaseSvgRenderer component={GlobeIcon} width="40" height="40" />
                <h2 className="header-m-medium">
                  {t("survey.labels.publicWebsiteVersion")}
                </h2>
                <p className="body-s-regular">
                  {t("survey.labels.publicWebsiteVersionDescription")}
                </p>
              </div>
            </Card>

            <Card className="report-version-card-community full-width">
              <div className="flex flex-col gap-100 items-center">
                <BaseSvgRenderer
                  component={CommunityIcon}
                  width="40"
                  height="40"
                />
                <h2 className="header-m-medium">
                  {t("survey.labels.communityVersion")}
                </h2>
                <p className="body-s-regular">
                  {t("survey.labels.communityVersionDescription")}
                </p>
              </div>
            </Card>
          </div>

          <p className="body-m-regular">
            {t("survey.labels.manageReportsHint")}
          </p>

          <div className="flex gap-100">
            <BaseButton
              variant={BUTTON_VARIANTS.TERTIARY}
              to={"/"}
              type={BUTTON_TYPES.LINK}
            >
              {t("survey.labels.returnToDashboard")}
            </BaseButton>
            <BaseButton
              variant={BUTTON_VARIANTS.PRIMARY}
              to={"/reports/views"}
              type={BUTTON_TYPES.LINK}
            >
              {t("survey.labels.goToPublishAndShare")}
            </BaseButton>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default SubmissionSuccess;
